module.exports = __webpack_public_path__ + "4b80a4f45a73dc3eccf02d2fdfbda261.png";